import data from "../../../../../src/PointerBox/PointerBox.docs.json";
import * as React from 'react';
export default {
  data,
  React
};